import { isEmpty } from 'lodash'
import Vue from 'vue'
import VueMatomo from 'vue-matomo'

export default async ({ app, $axios }) => {
  const matomoConfig = await $axios.$get('/matomo')

  if (isEmpty(matomoConfig) || !matomoConfig?.is_active || !matomoConfig.url || !matomoConfig.site_id) {
    return
  }

  Vue.use(VueMatomo, {
    host: matomoConfig.url,
    siteId: Number(matomoConfig.site_id),
    router: app.router,
    enableLinkTracking: true,
    requireConsent: true,
  })
}
